<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="120px"
    >
      <el-form-item
        label="appId"
        prop="appId"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.appId"
          placeholder="请输入appId名称"
        />
      </el-form-item>
      <el-form-item
        label="app名称"
        prop="appName"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.appName"
          maxlength="50"
          placeholder="请输入app名称"
        />
      </el-form-item>
      <el-form-item
        label="企业app安全码"
        prop="appSecurity"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.appSecurity"
          maxlength="128"
          placeholder="请输入企业app安全码"
        />
      </el-form-item>
      <el-form-item
        label="app类型"
        prop="appType"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.appType"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in appTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "FieldRequiredSettingAdd",
  data() {
    return {
      form: {
        appName: "",
        appId: "",
        appType: "",
        appSecurity: "",
      },
      appTypeOptions: [
        {
          value: "1",
          label: "安卓",
        },
        {
          value: "2",
          label: "IOS",
        },
      ],
      rules: {
        appId: [{ required: true, message: "请输入appId", trigger: "blur" }],
        appName: [
          { required: true, message: "请输入app名称", trigger: "blur" },
        ],
        appSecurity: [
          { required: true, message: "请输入app安全码", trigger: "blur" },
        ],
        appType: [
          { required: true, message: "请输入app类型", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {
    //提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/guangdongAppInfo",
            method: "post",
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
